import { Injectable } from '@angular/core';

import { toFixed } from '../../../../../../core/services/utils/numbers';
import { ClienteCentralCompraParticipante } from '../cliente-central-compra-participante';

@Injectable({
    providedIn: 'root'
})
export class ClienteCentralCompraParticipanteCalculoService {

    /** Calcular o percentual de participação total dos participantes de uma central de compras */
    calcularPercParticipacaoTotal(participantes: ClienteCentralCompraParticipante[]): number {
        if (!participantes) {
            return 0;
        }

        let participacaoTotal = 0;
        participantes.forEach(participante => {
            participacaoTotal += participante.percParticipacaoCentralCompra ? Number(participante.percParticipacaoCentralCompra) : 0;
        });

        return toFixed(participacaoTotal, 0);
    }
}
